export const LOOKING_FOR = {
  ID: 'LTM_LOOKING_FOR',
  LABEL_TOP: 'LookingFor',
  SUB_CONTENT_TITLE: 'YouCanSelectThanMoreOne',
};

export const AGE_RANGE = {
  ID: 'LTM_AGE_RANGE',
  LABEL_TOP: 'Age',
  SUB_CONTENT_TITLE: 'AgeRange',
};

export const INTENTIONS = {
  ID: 'LTM_INTENTIONS',
  LABEL_TOP: 'Intentions',
  SUB_CONTENT_TITLE: 'YouCanSelectThanMoreOne',
};

export const IAM_WEARE = {
  ID: 'ABOUT_YOUSELF_1',
  LABEL_TOP: 'I',
  SUB_CONTENT_TITLE: 'YouCanSelectThanMoreOne',
};

export const AGE_RANGE_DEFAULT = {
  DEFAULT: 18,
  MIN: 18,
  MAX: 65,
  AGE_100: 100,
};

export const AGE_RANGE_FILTER_DEFAULT = {
  DEFAULT: 18,
  MIN: 18,
  MAX: 80,
  MAX_100: 100,
};
